/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyExecuteRequest {
    getFixupPrototypeFunction() { return PolicyExecuteRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyExecuteRequest>): PolicyExecuteRequest {
        let obj = Object.assign(new PolicyExecuteRequest(), model);
        PolicyExecuteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyExecuteRequest>): PolicyExecuteRequest {
        if (!model) return null;
        return PolicyExecuteRequest.newInstance(<PolicyExecuteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyExecuteRequest) {
        if (!obj) return;

        models.PolicyExecuteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyExecuteRequest): boolean {
        Object.setPrototypeOf(obj, PolicyExecuteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_accounts) {
            for (let val of this.cloud_accounts) {
                models.PolicyServiceAccountDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * arguments to execute policy for example values can be in the below format {'listOfAllowedSKUs':['Basic_A0']} or {'requiredRetentionDays':'365','effect':'AuditIfNotExists'} etc.The values are dynamic in nature can change from policy to policy.The arguments required can be changed in the policy content in the view policy api
     */
    args: any;

    /**
     * cloud account details to execute the policy
     */
    cloud_accounts: Array<models.PolicyServiceAccountDetails>;

}
